import type { StockPorAlmacenDto } from '@/types/inventario';

interface Props {
  cantidad: number;
  desglose?: StockPorAlmacenDto[];
  /** Por defecto 5 — coincide con umbral_stock_bajo del backend */
  umbral?: number;
}

/**
 * Píldora de stock total con tooltip nativo mostrando desglose por almacén.
 * Color verde / amarillo / rojo según cantidad vs umbral.
 */
export function StockBadge({ cantidad, desglose, umbral = 5 }: Props) {
  const variant =
    cantidad === 0 ? 'rojo' : cantidad < umbral ? 'amarillo' : 'verde';

  const colorClass = {
    verde: 'bg-emerald-100 text-emerald-700 border-emerald-200',
    amarillo: 'bg-amber-100 text-amber-800 border-amber-200',
    rojo: 'bg-red-100 text-red-700 border-red-200',
  }[variant];

  const tooltip =
    desglose && desglose.length > 0
      ? desglose
          .map((s) => `${s.almacenNombre}: ${s.cantidad}`)
          .join(' | ')
      : 'Sin desglose por almacén';

  return (
    <span
      title={tooltip}
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold border ${colorClass}`}
    >
      {cantidad} ud
    </span>
  );
}
